import apiClient from "./axios"

// Fetch all filter options with counts
export const getFilterOptionsWithCounts = async params => {
  const { data } = await apiClient.get(
    "/vehicle-stocks/filters/options-with-counts",
    { params }
  )
  return data
}
